import { CanActivateFn, Router, RouterOutlet } from "@angular/router";
import { TokenStorageService } from "./token-storage.service";
import { inject } from "@angular/core";
import { MenuModel } from "../models/menu.model";

export const authGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  let tokenService = inject(TokenStorageService);
  const token = tokenService.getToken();
  let frameMappng: any = tokenService.getValidFrames();

  if ((state.url === '/login' || state.url === '/forget-password') && token != false && tokenService.isAuthenticated()) {
    _router.navigate(['dashboard/gender']);
    return false;
  } else if ((state.url === '/login' || state.url === '/forget-password') && (token == false || !tokenService.isAuthenticated())) {
    return true;
  } else if (token != false && tokenService.isAuthenticated()) {
    if (state.url.startsWith('/telephony') || state.url.startsWith('/contact-center') || state.url.startsWith('/call-center') || state.url.startsWith('/omnichannel')) {
      return true;
    }
    let routeExist = frameMappng?.filter((m: MenuModel) => state.url.includes(m.route))[0]
    if (routeExist) {
      return true;
    }
    _router.navigate(['dashboard/gender']);
    return false;
  } else {
    _router.navigate(['login']);
    return false;
  }

};
